var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editing)?_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.item.text)+" ")]):_c('div',[_c('textarea',{ref:"textUpdate",staticStyle:{"width":"100%"},attrs:{"rows":"15"}},[_vm._v(_vm._s(_vm.item.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }